import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NeighbourhoodSection = loadable(() => import("./NeighbourhoodSection"), {
  fallback: null as any,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <NeighbourhoodSection {...props} />
  </ErrorBoundary>
);
